export const CREATE = 'visitors/CREATE';